import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

export const Form = styled.form`
  width: 100%;
`;

export const Title = styled.h3`
  font-size: 17px;
  margin-bottom: ${layout.measurements.spacing150};
`;

export const Error = styled.p`
  font-size: 12px;
  color: ${p => p.theme.text.negative};
`;

export const Section = styled.div`
  width: 100%;
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing200};
`;

export const InputTitle = styled.p`
  margin-bottom: ${layout.measurements.spacing025};
`;

type RatingProps = {
  error: boolean;
};

export const Rating = styled.div<RatingProps>(
  props => css`
    svg {
      margin-right: ${layout.measurements.spacing050};
      height: 25px;

      &,
      path {
        ${props.error &&
          css`
            fill: ${props.theme.text.negative};
          `};
      }
    }
  `
);

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
`;

type CancelButtonProps = {
  alignRight: boolean;
};

export const CancelButton = styled(Button)<CancelButtonProps>`
  margin-left: ${p => (p.alignRight ? 'auto' : 0)};
  margin-right: ${layout.measurements.spacing050};
`;
